/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prompt_BodyInputs */



/**
* | output |
* | --- |
* | "Turn on notifications for table assignments and organizer announcements." |
*
* @param {Notifications_Prompt_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_prompt_body = /** @type {((inputs?: Notifications_Prompt_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prompt_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activez les notifications pour vos placements à une table et les annonces de l’organisateur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Active las notificaciones para su asignación de mesa y los anuncios del organizador.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ative as notificações para os assentos da sua mesa e os anúncios do organizador.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva le notifiche per il tuo posto al tavolo e gli annunci dell’organizzatore.")
	return /** @type {LocalizedString} */ ("Turn on notifications for table assignments and organizer announcements.")
});